import { render } from "./headerH5.vue?vue&type=template&id=4420b6a3"
import script from "./headerH5.vue?vue&type=script&lang=js"
export * from "./headerH5.vue?vue&type=script&lang=js"

import "./headerH5.vue?vue&type=style&index=0&id=4420b6a3&lang=less"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.38_webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__